import { Box, Button } from "@mui/material";
import DataList from "components/DataList";
import GenericModal from "components/GenericModal";
import MDTypography from "components/MDTypography";
import { useAppContextController } from "context/AppContext";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
import InterviewApplicantRow from "./InterviewApplicantRow";

const InterviewApplicantsModal = ({
  open,
  setOpen,
  event,
  applicant,
  refetchApplicants,
  onChangeFeedback,
}) => {
  const { currentLoggedUser } = useAppContextController();
  const { enqueueSnackbar } = useSnackbar();

  const [selectedUser, setSelectedUser] = useState(null);
  const [currentApplicant, setCurrentApplicant] = useState(applicant);

  const header = (
    <MDTypography variant="h5" color="dark" sx={{ mt: 2, mb: 1, ml: 2 }}>
      Interview Applicants
    </MDTypography>
  );

  const modalBody = (
    <Box>
      <DataList
        renderRow={(row, idx) => (
          <InterviewApplicantRow
            row={row}
            idx={idx}
            applicants={event?.applicants}
            readOnly
            allowSetFeedback
            currentEvent={event}
            refetchApplicants={refetchApplicants}
            onChangeFeedback={onChangeFeedback}
          />
        )}
        data={event?.applicants}
        greybar
        divider
        scrollY
        tableHeight={200}
        height={250}
        isLoading={false}
        noPadding
      />
    </Box>
  );

  const buttons = (
    <>
      <Box display="flex" flexDirection="column" sx={{ paddingRight: "1rem" }}>
        <Button
          variant="contained"
          style={{ color: "white" }}
          onClick={(e) => {
            setOpen(false);
          }}
        >
          Close
        </Button>
      </Box>
    </>
  );

  return (
    <>
      <GenericModal
        open={open}
        setOpen={setOpen}
        body={modalBody}
        header={header}
        buttons={buttons}
        sx={(theme) => ({
          width: "90% !important",
          maxWidth: "1100px !important",
          // paddingBottom: "10px",
          [theme.breakpoints.down("md")]: {
            "& .MuiCardContent-root": {
              padding: "0px",
            },
          },
        })}
      />
    </>
  );
};

export default InterviewApplicantsModal;
